import { computed } from "vue";
const useParsable = (parsable, parse, format) => {
  const text = computed({
    get() {
      const value2 = parsable.value;
      if (typeof value2 === "string") {
        return value2;
      }
      return format(value2);
    },
    set(v) {
      if (typeof parsable.value === "string") {
        parsable.value = v;
      } else {
        parsable.value = parse(v);
      }
    }
  });
  const value = computed({
    get() {
      if (typeof parsable.value === "string") {
        return parse(parsable.value);
      }
      return parsable.value;
    },
    set(v) {
      if (typeof parsable.value === "string") {
        parsable.value = format(v);
      } else {
        parsable.value = v;
      }
    }
  });
  return {
    text,
    value
  };
};
export {
  useParsable as u
};
//# sourceMappingURL=useParsable-6103c13e.mjs.map
